import React from 'react';
import PartnerContactPage from './partner-contact';

export default function render(entry, pageTree) {
    return <PartnerContactPage entry={entry} pageTree={pageTree} />;
}
